import { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import { Inclusion } from "../../../componentes/Padron/ComponenteInclusion/Inclusion";

export class InclusionSolicitud extends Component {
  render() {
    return (
      <Layout>
        <div>
          <Inclusion />
        </div>
      </Layout>
    );
  }
}

export default InclusionSolicitud;
